import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileUploadResponseDto } from 'src/app/data/models/dto/file-upload-response.dto';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { FileService } from 'src/app/data/services/file.service';

@Component({
  selector: 'app-chat-file-uploader',
  templateUrl: './chat-file-uploader.component.html',
  styleUrls: ['./chat-file-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatFileUploaderComponent implements OnInit {
  constructor(private readonly fileService: FileService) {}

  @Output() onCancel = new EventEmitter<boolean>();
  @Output() onSuccess = new EventEmitter<FileDto>();

  @Input() file!: File;

  cancelUpload = new Subject<boolean>();

  async ngOnInit(): Promise<void> {
    this.cancelUpload.next(false);
    try {
      const fileResponse: FileUploadResponseDto = await this.fileService
        .uploadV3([this.file], '')
        .pipe(takeUntil(this.cancelUpload.asObservable()))
        .toPromise();

      this.onSuccess.emit(fileResponse.success[0]);
    } catch (error) {
      this.onSuccess.emit(undefined);
    }
  }

  cancel(event: boolean) {
    this.cancelUpload.next(true);
    this.onCancel.emit(event);
  }
}
